/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/app.js"
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
() {

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
/******/
(function () {
  // webpackBootstrap
  /******/
  "use strict";

  /******/
  var __webpack_modules__ = {
    /***/"./resources/app.ts":
    /*!**************************!*\
    !*** ./resources/app.ts ***!
    \**************************/
    /***/
    function _resources_appTs(__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_1973__) {
      __nested_webpack_require_1973__.r(__nested_webpack_exports__);
      /* harmony import */
      var _scripts_components_MapComponent_MapComponent__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1973__(/*! ./scripts/components/MapComponent/MapComponent */"./resources/scripts/components/MapComponent/MapComponent.ts");
      customElements.define("map-component", _scripts_components_MapComponent_MapComponent__WEBPACK_IMPORTED_MODULE_0__["default"]);

      /***/
    },
    /***/"./resources/scripts/components/MapComponent/GoogleMaps.ts":
    /*!*****************************************************************!*\
    !*** ./resources/scripts/components/MapComponent/GoogleMaps.ts ***!
    \*****************************************************************/
    /***/
    function _resources_scripts_components_MapComponent_GoogleMapsTs(__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_2865__) {
      __nested_webpack_require_2865__.r(__nested_webpack_exports__);
      /* harmony export */
      __nested_webpack_require_2865__.d(__nested_webpack_exports__, {
        /* harmony export */"default": function _default() {
          return /* binding */GoogleMaps;
        }
        /* harmony export */
      });
      /* harmony import */
      var _Places__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2865__(/*! ./Places */"./resources/scripts/components/MapComponent/Places.ts");
      function _typeof(o) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
          return typeof o;
        } : function (o) {
          return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
      }
      function _regeneratorRuntime() {
        "use strict";

        /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
        _regeneratorRuntime = function _regeneratorRuntime() {
          return e;
        };
        var t,
          e = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (t, e, r) {
            t[e] = r.value;
          },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";
        function define(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }
        try {
          define({}, "");
        } catch (t) {
          define = function define(t, e, r) {
            return t[e] = r;
          };
        }
        function wrap(t, e, r, n) {
          var i = e && e.prototype instanceof Generator ? e : Generator,
            a = Object.create(i.prototype),
            c = new Context(n || []);
          return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
          }), a;
        }
        function tryCatch(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }
        e.wrap = wrap;
        var h = "suspendedStart",
          l = "suspendedYield",
          f = "executing",
          s = "completed",
          y = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        var p = {};
        define(p, a, function () {
          return this;
        });
        var d = Object.getPrototypeOf,
          v = d && d(d(values([])));
        v && v !== r && n.call(v, a) && (p = v);
        var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
        function defineIteratorMethods(t) {
          ["next", "throw", "return"].forEach(function (e) {
            define(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function AsyncIterator(t, e) {
          function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
              var u = c.arg,
                h = u.value;
              return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                invoke("next", t, i, a);
              }, function (t) {
                invoke("throw", t, i, a);
              }) : e.resolve(h).then(function (t) {
                u.value = t, i(u);
              }, function (t) {
                return invoke("throw", t, i, a);
              });
            }
            a(c.arg);
          }
          var r;
          o(this, "_invoke", {
            value: function value(t, n) {
              function callInvokeWithMethodAndArg() {
                return new e(function (e, r) {
                  invoke(t, n, e, r);
                });
              }
              return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
          });
        }
        function makeInvokeMethod(e, r, n) {
          var o = h;
          return function (i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
              if ("throw" === i) throw a;
              return {
                value: t,
                done: !0
              };
            }
            for (n.method = i, n.arg = a;;) {
              var c = n.delegate;
              if (c) {
                var u = maybeInvokeDelegate(c, n);
                if (u) {
                  if (u === y) continue;
                  return u;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (o === h) throw o = s, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              o = f;
              var p = tryCatch(e, r, n);
              if ("normal" === p.type) {
                if (o = n.done ? s : l, p.arg === y) continue;
                return {
                  value: p.arg,
                  done: n.done
                };
              }
              "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
          };
        }
        function maybeInvokeDelegate(e, r) {
          var n = r.method,
            o = e.iterator[n];
          if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
          var i = tryCatch(o, e.iterator, r.arg);
          if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
          var a = i.arg;
          return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
        }
        function pushTryEntry(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }
        function resetTryEntry(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }
        function Context(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(pushTryEntry, this), this.reset(!0);
        }
        function values(e) {
          if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function next() {
                  for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                  return next.value = t, next.done = !0, next;
                };
              return i.next = i;
            }
          }
          throw new TypeError(_typeof(e) + " is not iterable");
        }
        return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
          value: GeneratorFunctionPrototype,
          configurable: !0
        }), o(GeneratorFunctionPrototype, "constructor", {
          value: GeneratorFunction,
          configurable: !0
        }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
        }, e.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
        }, e.awrap = function (t) {
          return {
            __await: t
          };
        }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
          return this;
        }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new AsyncIterator(wrap(t, r, n, o), i);
          return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
          return this;
        }), define(g, "toString", function () {
          return "[object Generator]";
        }), e.keys = function (t) {
          var e = Object(t),
            r = [];
          for (var n in e) r.push(n);
          return r.reverse(), function next() {
            for (; r.length;) {
              var t = r.pop();
              if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
          };
        }, e.values = values, Context.prototype = {
          constructor: Context,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
              return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return handle("end");
              if (i.tryLoc <= this.prev) {
                var c = n.call(i, "catchLoc"),
                  u = n.call(i, "finallyLoc");
                if (c && u) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                } else if (c) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                } else {
                  if (!u) throw Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
          },
          "catch": function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.tryLoc === t) {
                var n = r.completion;
                if ("throw" === n.type) {
                  var o = n.arg;
                  resetTryEntry(r);
                }
                return o;
              }
            }
            throw Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
              iterator: values(e),
              resultName: r,
              nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
          }
        }, e;
      }
      function asyncGeneratorStep(n, t, e, r, o, a, c) {
        try {
          var i = n[a](c),
            u = i.value;
        } catch (n) {
          return void e(n);
        }
        i.done ? t(u) : Promise.resolve(u).then(r, o);
      }
      function _asyncToGenerator(n) {
        return function () {
          var t = this,
            e = arguments;
          return new Promise(function (r, o) {
            var a = n.apply(t, e);
            function _next(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
          });
        };
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[r] = t, e;
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      function _toPrimitive(t, r) {
        if ("object" != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      var GoogleMaps = /*#__PURE__*/function () {
        function GoogleMaps() {
          _classCallCheck(this, GoogleMaps);
          _defineProperty(this, "map", void 0);
          this.initGoogleMapsScript = this.initGoogleMapsScript.bind(this);
          this.initMap = this.initMap.bind(this);
          this.addMarkers = this.addMarkers.bind(this);
          this.handleMissingParams = this.handleMissingParams.bind(this);
          this.panPinIntoView = this.panPinIntoView.bind(this);
        }
        // Method to initialize the google maps script
        /* eslint-disable */
        return _createClass(GoogleMaps, [{
          key: "initGoogleMapsScript",
          value: function initGoogleMapsScript(apiKey, version, language, region) {
            var script = document.createElement("script");
            script.innerHTML = '\n (g => {\n var h, a, k, p = "The Google Maps JavaScript API",\n c = "google", l = "importLibrary", q = "__ib__",\n m = document, b = window;\n b = b[c] || (b[c] = {});\n var d = b.maps || (b.maps = {}),\n r = new Set, e = new URLSearchParams,\n u = () => h || (h = new Promise(async (f, n) => {\n await (a = m.createElement("script"));\n e.set("libraries", [...r] + "");\n for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);\n e.set("callback", c + ".maps." + q);\n a.src = `https://maps.${c}apis.com/maps/api/js?` + e;\n d[q] = f;\n a.onerror = () => h = n(Error(p + " could not load."));\n a.nonce = m.querySelector("script[nonce]")?.nonce || "";\n m.head.append(a);\n }));\n d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));\n })({\n key: "'.concat(apiKey, '",\n v: "').concat(version, '",\n language: "').concat(language, '",\n region: "').concat(region, '",\n });\n ');
            document.body.appendChild(script);
          }
          /* eslint-disable */
          // Method to initialize the map
        }, {
          key: "initMap",
          // Method to add markers to the map
          value: function () {
            var _initMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(apiKey, version, language, region) {
              var _this = this;
              var missingParams, _yield$google$maps$im, Map, PlacesApi;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    missingParams = this.handleMissingParams(apiKey, version, language, region);
                    if (!missingParams) {
                      _context.next = 4;
                      break;
                    }
                    console.error(missingParams);
                    return _context.abrupt("return");
                  case 4:
                    this.initGoogleMapsScript(apiKey, version, language, region);
                    _context.next = 7;
                    return google.maps.importLibrary("maps");
                  case 7:
                    _yield$google$maps$im = _context.sent;
                    Map = _yield$google$maps$im.Map;
                    this.map = new Map(document.getElementById("map"), {
                      center: {
                        lat: 55.56682,
                        lng: 9.75452
                      },
                      zoom: 4,
                      mapId: "ec10f55bcbe31d2b"
                    });
                    this.addMarkers(this.map);
                    document.addEventListener("Edition:PanPinIntoView", function (event) {
                      _this.panPinIntoView(event, _this.map);
                    });
                    PlacesApi = new _Places__WEBPACK_IMPORTED_MODULE_0__["default"]();
                    _context.next = 15;
                    return PlacesApi.init();
                  case 15:
                  case "end":
                    return _context.stop();
                }
              }, _callee, this);
            }));
            function initMap(_x, _x2, _x3, _x4) {
              return _initMap.apply(this, arguments);
            }
            return initMap;
          }()
        }, {
          key: "addMarkers",
          value: function () {
            var _addMarkers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(map) {
              var _this2 = this;
              var _yield$google$maps$im2, InfoWindow, _yield$google$maps$im3, AdvancedMarkerElement, PinElement, markers, infoWindow, storeLocator;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return google.maps.importLibrary("maps");
                  case 2:
                    _yield$google$maps$im2 = _context2.sent;
                    InfoWindow = _yield$google$maps$im2.InfoWindow;
                    _context2.next = 6;
                    return google.maps.importLibrary("marker");
                  case 6:
                    _yield$google$maps$im3 = _context2.sent;
                    AdvancedMarkerElement = _yield$google$maps$im3.AdvancedMarkerElement;
                    PinElement = _yield$google$maps$im3.PinElement;
                    // Get the markers from the window object (Our stores)
                    markers = window.advancedMarkerData; // Create an info window to share between markers.
                    infoWindow = new InfoWindow();
                    storeLocator = document.querySelector("map-component");
                    console.log;
                    // Loop through the markers and add them to the map. We use the PinElement to create a custom marker
                    markers.forEach(function (marker) {
                      var glyphImg;
                      if (storeLocator.dataset.pinglyphimg) {
                        glyphImg = document.createElement("img");
                        glyphImg.style.width = "22px";
                        glyphImg.style.height = "22px";
                        glyphImg.style.marginTop = "-60px";
                        glyphImg.src = storeLocator.dataset.pinglyphimg;
                      } else {
                        glyphImg === null;
                      }
                      var pin = new PinElement({
                        scale: 9,
                        background: storeLocator.dataset.pinbackground,
                        borderColor: storeLocator.dataset.pinbordercolor,
                        glyphColor: storeLocator.dataset.pinglyphcolor,
                        glyph: glyphImg
                      });
                      var newMarker = new AdvancedMarkerElement({
                        map: _this2.map,
                        position: marker.position,
                        title: marker.title,
                        content: pin.element,
                        gmpClickable: true
                      });
                      newMarker.addListener("mouseover", function () {});
                      newMarker.addListener("click", function (_ref) {
                        var domEvent = _ref.domEvent,
                          latLng = _ref.latLng;
                        // fire a custom event. We listen for this event in the map-component component
                        document.dispatchEvent(new CustomEvent("Edition:findStoreInList", {
                          detail: {
                            position: newMarker.position
                          }
                        }));
                        console.log(newMarker.position);
                        var target = domEvent.target;
                        infoWindow.close();
                        /* Replace htmlEle innerHTML with the html you want in the content
                        const htmlEle = document.createElement('div');
                        htmlEle.innerHTML = `
                        `;
                        infoWindow.setContent(htmlEle);
                        */
                        infoWindow.open(newMarker.map, newMarker);
                      });
                    });
                  case 14:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            function addMarkers(_x5) {
              return _addMarkers.apply(this, arguments);
            }
            return addMarkers;
          }() // Method to pan the map to a marker. This method is called when a search is performed. Fired when Edition:PanPinIntoView is dispatched
        }, {
          key: "panPinIntoView",
          value: function panPinIntoView(event, map) {
            // turn lat and lng into numbers
            var markerPosition = {
              lat: Number(event.detail.position.lat),
              lng: Number(event.detail.position.lng)
            };
            map.panTo(markerPosition);
            map.setZoom(10);
          }
          // Method to handle missing params
        }, {
          key: "handleMissingParams",
          value: function handleMissingParams(apiKey, version, language, region) {
            if (!apiKey) {
              return "Edition - Missing Google Maps API Key Param";
            }
            if (!version) {
              return "Edition - Missing Google Maps Version Param";
            }
            if (!language) {
              return "Edition - Missing Google Maps Language Param";
            }
            if (!region) {
              return "Edition - Missing Google Maps Region Param";
            }
            return null;
          }
        }]);
      }();

      /***/
    },
    /***/"./resources/scripts/components/MapComponent/MapComponent.ts":
    /*!*******************************************************************!*\
    !*** ./resources/scripts/components/MapComponent/MapComponent.ts ***!
    \*******************************************************************/
    /***/
    function _resources_scripts_components_MapComponent_MapComponentTs(__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_28668__) {
      __nested_webpack_require_28668__.r(__nested_webpack_exports__);
      /* harmony export */
      __nested_webpack_require_28668__.d(__nested_webpack_exports__, {
        /* harmony export */"default": function _default() {
          return /* binding */MapComponent;
        }
        /* harmony export */
      });
      /* harmony import */
      var _GoogleMaps__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_28668__(/*! ./GoogleMaps */"./resources/scripts/components/MapComponent/GoogleMaps.ts");
      function _typeof(o) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
          return typeof o;
        } : function (o) {
          return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function _callSuper(t, o, e) {
        return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
      }
      function _possibleConstructorReturn(t, e) {
        if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(t);
      }
      function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function _inherits(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e && _setPrototypeOf(t, e);
      }
      function _wrapNativeSuper(t) {
        var r = "function" == typeof Map ? new Map() : void 0;
        return _wrapNativeSuper = function _wrapNativeSuper(t) {
          if (null === t || !_isNativeFunction(t)) return t;
          if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
          if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
          }
          function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
          }
          return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
              value: Wrapper,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), _setPrototypeOf(Wrapper, t);
        }, _wrapNativeSuper(t);
      }
      function _construct(t, e, r) {
        if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
        var o = [null];
        o.push.apply(o, e);
        var p = new (t.bind.apply(t, o))();
        return r && _setPrototypeOf(p, r.prototype), p;
      }
      function _isNativeReflectConstruct() {
        try {
          var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (t) {}
        return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
          return !!t;
        })();
      }
      function _isNativeFunction(t) {
        try {
          return -1 !== Function.toString.call(t).indexOf("[native code]");
        } catch (n) {
          return "function" == typeof t;
        }
      }
      function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
          return t.__proto__ = e, t;
        }, _setPrototypeOf(t, e);
      }
      function _getPrototypeOf(t) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, _getPrototypeOf(t);
      }
      function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[r] = t, e;
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      function _toPrimitive(t, r) {
        if ("object" != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      /* eslint-disable class-methods-use-this */

      var MapComponent = /*#__PURE__*/function (_HTMLElement) {
        function MapComponent() {
          var _this;
          _classCallCheck(this, MapComponent);
          _this = _callSuper(this, MapComponent);
          _defineProperty(_this, "apiKey", "AIzaSyD76hbYUNIylH-H124PCtFtp6yiweh1Jz0");
          _defineProperty(_this, "version", _this.dataset.version);
          _defineProperty(_this, "language", _this.dataset.language);
          _defineProperty(_this, "region", _this.dataset.region);
          _defineProperty(_this, "loader", _this.querySelector(".map-component__loader"));
          // Declare the debouncedSearch property
          _defineProperty(_this, "debouncedSearch", void 0);
          _this.handleMapAndList = _this.handleMapAndList.bind(_this);
          _this.handleRegionSelection = _this.handleRegionSelection.bind(_this);
          _this.setAriaAttribute = _this.setAriaAttribute.bind(_this);
          _this.getVisitorLocation = _this.getVisitorLocation.bind(_this);
          _this.handleShowNearbyStores = _this.handleShowNearbyStores.bind(_this);
          _this.findStoreFromMarker = _this.findStoreFromMarker.bind(_this);
          _this.calculateDistanceFromVisitor = _this.calculateDistanceFromVisitor.bind(_this);
          _this.isWithinDistance = _this.isWithinDistance.bind(_this);
          _this.sortLocationsByDistanceFromPosition = _this.sortLocationsByDistanceFromPosition.bind(_this);
          _this.sortLocationsByDataAttribute = _this.sortLocationsByDataAttribute.bind(_this);
          _this.sortStoresByDistanceFromSelectedPosition = _this.sortStoresByDistanceFromSelectedPosition.bind(_this);
          _this.handleDebounce = _this.handleDebounce.bind(_this);
          _this.debouncedSearch = _this.handleDebounce(_this.sortLocationsByDataAttribute, 300);
          return _this;
        }
        _inherits(MapComponent, _HTMLElement);
        return _createClass(MapComponent, [{
          key: "connectedCallback",
          value: function connectedCallback() {
            var _this2 = this;
            this.initGoogleMaps();
            this.getVisitorLocation();
            // When clicking on one of the action buttons. Set the aria-selected attribute to true and handle the map and list
            var actionBtns = Array.from(this.querySelectorAll(".map-component-action-btn"));
            actionBtns.forEach(function (btn) {
              btn.addEventListener("click", function (event) {
                event.preventDefault();
                _this2.handleMapAndList(btn);
              });
            });
            // When clicking on one of the regions. Set the aria-selected attribute to true and handle the region selection
            var listRegionsBtns = Array.from(this.querySelectorAll(".map-component-region"));
            listRegionsBtns.forEach(function (btn) {
              btn.addEventListener("click", function (event) {
                event.preventDefault();
                _this2.handleRegionSelection(btn);
              });
            });
            /* const searchEle = this.querySelector('input[type="search"]') as HTMLInputElement;
            searchEle.addEventListener('input', () => {
            const searchTerm = searchEle.value;
            this.debouncedSearch(searchTerm);
            });
            */
            document.addEventListener("Edition:findStoreInList", function (event) {
              _this2.findStoreFromMarker(event);
            });
            document.addEventListener("Edition:FindNearbyStores", function (event) {
              _this2.handleShowNearbyStores(event.detail.position.lat, event.detail.position.lng);
            });
            document.addEventListener("Edition:ShowMap", function () {
              _this2.handleMapAndList(_this2.querySelector('.map-component-action-btn[data-action="map"]'));
              var storesWrapperInMapView = document.querySelector(".map-component__map-stores");
              storesWrapperInMapView.setAttribute("aria-hidden", "false");
            });
          }
        }, {
          key: "initGoogleMaps",
          value: function initGoogleMaps() {
            var googleMaps = new _GoogleMaps__WEBPACK_IMPORTED_MODULE_0__["default"]();
            googleMaps.initMap(this.apiKey, this.version, this.language, this.region);
          }
        }, {
          key: "getVisitorLocation",
          value: function getVisitorLocation() {
            this.sortLocationsByDataAttribute();
            /* const successCallback = (position) => {
            const { latitude } = position.coords;
            const { longitude } = position.coords;
            if (latitude && longitude) {
            this.sortLocationsByDistanceFromPosition(latitude, longitude);
            }
            };
            const errorCallback = () => {
            this.sortLocationsByDataAttribute();
            };
            if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
            } else {
            this.sortLocationsByDataAttribute();
            }
            */
          }
        }, {
          key: "sortLocationsByDataAttribute",
          value: function sortLocationsByDataAttribute() {
            var locationsList = Array.from(this.querySelectorAll(".location-list-wrapper"));
            locationsList.forEach(function (locationList) {
              var allLocations = Array.from(locationList.querySelectorAll(".location"));
              var sortedLocations = [];
              // Sort the stores by the data-order attribute. If the
              sortedLocations = allLocations.sort(function (a, b) {
                return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
              });
              // Append the sorted stores to the store wrapper
              sortedLocations.forEach(function (location) {
                locationList.appendChild(location);
                location.classList.remove("!tw-hidden");
              });
            });
            this.loader.classList.add("!tw-hidden");
          }
        }, {
          key: "sortLocationsByDistanceFromPosition",
          value: function sortLocationsByDistanceFromPosition(latitude, longitude) {
            var _this3 = this;
            var locationsList = Array.from(this.querySelectorAll(".location-list-wrapper"));
            locationsList.forEach(function (locationList) {
              var allLocations = Array.from(locationList.querySelectorAll(".location"));
              var sortedLocations = [];
              // The closer the distance is to 0, the closer the store is to the visitor
              sortedLocations = allLocations.sort(function (a, b) {
                var aDistance = _this3.calculateDistanceFromVisitor(latitude, longitude, parseFloat(a.dataset.latitude), parseFloat(a.dataset.longitude));
                var bDistance = _this3.calculateDistanceFromVisitor(latitude, longitude, parseFloat(b.dataset.latitude), parseFloat(b.dataset.longitude));
                return aDistance - bDistance;
              });
              // Append the sorted stores to the store wrapper
              sortedLocations.forEach(function (location) {
                locationList.appendChild(location);
                location.classList.remove("!tw-hidden");
              });
              _this3.loader.classList.add("!tw-hidden");
            });
          }
        }, {
          key: "sortStoresByDistanceFromSelectedPosition",
          value: function sortStoresByDistanceFromSelectedPosition(sortedLocations, latitude, longitude) {
            var _this4 = this;
            sortedLocations.sort(function (a, b) {
              var aDistance = _this4.calculateDistanceFromVisitor(latitude, longitude, parseFloat(a.dataset.latitude), parseFloat(a.dataset.longitude));
              var bDistance = _this4.calculateDistanceFromVisitor(latitude, longitude, parseFloat(b.dataset.latitude), parseFloat(b.dataset.longitude));
              return aDistance - bDistance;
            });
            // Append the sorted stores to the store wrapper
            sortedLocations.forEach(function (location) {
              location.parentElement.appendChild(location);
            });
          }
        }, {
          key: "handleShowNearbyStores",
          value: function handleShowNearbyStores(latitude, longitude) {
            var _this5 = this;
            var sortedLocations = [];
            var locationsList = Array.from(this.querySelectorAll(".location-list-wrapper"));
            locationsList.forEach(function (locationList) {
              var allLocations = Array.from(locationList.querySelectorAll(".location"));
              if (latitude == null || longitude == null) {
                allLocations.forEach(function (location) {
                  location.classList.remove("!tw-hidden");
                });
              } else {
                allLocations.forEach(function (location) {
                  var locationLatitude = parseFloat(location.dataset.latitude);
                  var locationLongitude = parseFloat(location.dataset.longitude);
                  // if the store is within a given distance, show it
                  if (!_this5.isWithinDistance(latitude, longitude, locationLatitude, locationLongitude)) {
                    location.classList.add("!tw-hidden");
                  } else {
                    location.classList.remove("!tw-hidden");
                    sortedLocations.push(location);
                  }
                });
                _this5.sortStoresByDistanceFromSelectedPosition(sortedLocations, latitude, longitude);
              }
            });
          }
        }, {
          key: "calculateDistanceFromVisitor",
          value: function calculateDistanceFromVisitor(lat1, lon1, lat2, lon2) {
            if (lat1 == null || lon1 == null) {
              return null;
            }
            // return the distance between lat1, lon1 and lat2, lon2 in numbers
            var latDiff = lat1 - lat2;
            var lonDiff = lon1 - lon2;
            return Math.sqrt(latDiff * latDiff + lonDiff * lonDiff);
          }
        }, {
          key: "isWithinDistance",
          value: function isWithinDistance(lat1, lon1, lat2, lon2) {
            // 1 lat = 110.574 km
            // 1 long = 111.320*cos(lat) km
            // 1km = 0.009043717329571 deg, 0.008983111749909 deg
            // 10km = 0.09043717329571 deg, 0.08983111749909 deg
            // 30km = 0.27231151988713 deg, 0.26949335249727 deg
            // 50km = 0.45419586647855 deg, 0.44915558749545 deg
            return Math.abs(lat1 - lat2) < 0.4541958664785 && Math.abs(lon1 - lon2) < 0.44915558749545;
          }
          // Handle the map and list selection
        }, {
          key: "handleMapAndList",
          value: function handleMapAndList(btn) {
            var actionBtns = Array.from(this.querySelectorAll(".map-component-action-btn"));
            this.setAriaAttribute(actionBtns, btn, "aria-selected");
            var action = btn.dataset.action;
            var mapContent = this.querySelector('.map-component-content__type[data-action="map"]');
            var listContent = this.querySelector('.map-component-content__type[data-action="list"]');
            if (action === "list") {
              this.setAriaAttribute([mapContent, listContent], mapContent, "aria-hidden");
            } else if (action === "map") {
              this.setAriaAttribute([mapContent, listContent], listContent, "aria-hidden");
            }
          }
          // Handle the region selection
        }, {
          key: "handleRegionSelection",
          value: function handleRegionSelection(btn) {
            this.getVisitorLocation(); // Sort the stores by distance from the visitor
            var listRegionsBtns = Array.from(this.querySelectorAll(".map-component-region"));
            this.setAriaAttribute(listRegionsBtns, btn, "aria-selected");
            var region = btn.dataset.regionname;
            var activeRegion = this.querySelector('.map-component-region-wrapper[data-regionname="'.concat(region, '"]'));
            var regionWrappers = Array.from(this.querySelectorAll(".map-component-region-wrapper"));
            this.setAriaAttribute(regionWrappers, activeRegion, "aria-expanded");
          }
        }, {
          key: "findStoreFromMarker",
          value: function findStoreFromMarker(event) {
            var _this6 = this;
            var markerPosition = {
              lat: event.detail.position.lat,
              lng: event.detail.position.lng
            };
            // turn the marker position into a string, so we can search for it
            var markerPositionStr = "".concat(markerPosition.lat, ",").concat(markerPosition.lng);
            var allLocations = Array.from(this.querySelectorAll(".location"));
            allLocations.forEach(function (location) {
              location.classList.add("!tw-hidden");
              var locationPosition = {
                lat: parseFloat(location.dataset.latitude),
                lng: parseFloat(location.dataset.longitude)
              };
              var locationPositionStr = "".concat(locationPosition.lat, ",").concat(locationPosition.lng);
              if (locationPositionStr === markerPositionStr) {
                console.log(location, "location");
                location.classList.remove("!tw-hidden");
                var locationListWrapper = _this6.querySelector(".map-component__map-stores");
                console.log(locationListWrapper, "locationListWrapper");
                locationListWrapper.setAttribute("aria-hidden", "false");
              }
            });
          }
          /* eslint-disable */
        }, {
          key: "handleDebounce",
          value: function handleDebounce(func, wait) {
            var timeout;
            return function executedFunction() {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              var later = function later() {
                timeout = null;
                func.apply(void 0, args);
              };
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
            };
          }
          /* eslint-disable */
          /* eslint-disable */
        }, {
          key: "setAriaAttribute",
          value: function setAriaAttribute(elements, element, state) {
            elements.forEach(function (ele) {
              ele.setAttribute(state, "false");
            });
            element.setAttribute(state, "true");
          }
        }]);
      }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));

      /***/
    },
    /***/"./resources/scripts/components/MapComponent/Places.ts":
    /*!*************************************************************!*\
    !*** ./resources/scripts/components/MapComponent/Places.ts ***!
    \*************************************************************/
    /***/
    function _resources_scripts_components_MapComponent_PlacesTs(__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_49489__) {
      __nested_webpack_require_49489__.r(__nested_webpack_exports__);
      /* harmony export */
      __nested_webpack_require_49489__.d(__nested_webpack_exports__, {
        /* harmony export */"default": function _default() {
          return /* binding */Places;
        }
        /* harmony export */
      });
      function _typeof(o) {
        "@babel/helpers - typeof";

        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
          return typeof o;
        } : function (o) {
          return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
      }
      function _regeneratorRuntime() {
        "use strict";

        /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
        _regeneratorRuntime = function _regeneratorRuntime() {
          return e;
        };
        var t,
          e = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (t, e, r) {
            t[e] = r.value;
          },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";
        function define(t, e, r) {
          return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), t[e];
        }
        try {
          define({}, "");
        } catch (t) {
          define = function define(t, e, r) {
            return t[e] = r;
          };
        }
        function wrap(t, e, r, n) {
          var i = e && e.prototype instanceof Generator ? e : Generator,
            a = Object.create(i.prototype),
            c = new Context(n || []);
          return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
          }), a;
        }
        function tryCatch(t, e, r) {
          try {
            return {
              type: "normal",
              arg: t.call(e, r)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }
        e.wrap = wrap;
        var h = "suspendedStart",
          l = "suspendedYield",
          f = "executing",
          s = "completed",
          y = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        var p = {};
        define(p, a, function () {
          return this;
        });
        var d = Object.getPrototypeOf,
          v = d && d(d(values([])));
        v && v !== r && n.call(v, a) && (p = v);
        var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
        function defineIteratorMethods(t) {
          ["next", "throw", "return"].forEach(function (e) {
            define(t, e, function (t) {
              return this._invoke(e, t);
            });
          });
        }
        function AsyncIterator(t, e) {
          function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
              var u = c.arg,
                h = u.value;
              return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                invoke("next", t, i, a);
              }, function (t) {
                invoke("throw", t, i, a);
              }) : e.resolve(h).then(function (t) {
                u.value = t, i(u);
              }, function (t) {
                return invoke("throw", t, i, a);
              });
            }
            a(c.arg);
          }
          var r;
          o(this, "_invoke", {
            value: function value(t, n) {
              function callInvokeWithMethodAndArg() {
                return new e(function (e, r) {
                  invoke(t, n, e, r);
                });
              }
              return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
          });
        }
        function makeInvokeMethod(e, r, n) {
          var o = h;
          return function (i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
              if ("throw" === i) throw a;
              return {
                value: t,
                done: !0
              };
            }
            for (n.method = i, n.arg = a;;) {
              var c = n.delegate;
              if (c) {
                var u = maybeInvokeDelegate(c, n);
                if (u) {
                  if (u === y) continue;
                  return u;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (o === h) throw o = s, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              o = f;
              var p = tryCatch(e, r, n);
              if ("normal" === p.type) {
                if (o = n.done ? s : l, p.arg === y) continue;
                return {
                  value: p.arg,
                  done: n.done
                };
              }
              "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
          };
        }
        function maybeInvokeDelegate(e, r) {
          var n = r.method,
            o = e.iterator[n];
          if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
          var i = tryCatch(o, e.iterator, r.arg);
          if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
          var a = i.arg;
          return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
        }
        function pushTryEntry(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }
        function resetTryEntry(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }
        function Context(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(pushTryEntry, this), this.reset(!0);
        }
        function values(e) {
          if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                i = function next() {
                  for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                  return next.value = t, next.done = !0, next;
                };
              return i.next = i;
            }
          }
          throw new TypeError(_typeof(e) + " is not iterable");
        }
        return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
          value: GeneratorFunctionPrototype,
          configurable: !0
        }), o(GeneratorFunctionPrototype, "constructor", {
          value: GeneratorFunction,
          configurable: !0
        }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
          var e = "function" == typeof t && t.constructor;
          return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
        }, e.mark = function (t) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
        }, e.awrap = function (t) {
          return {
            __await: t
          };
        }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
          return this;
        }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
          void 0 === i && (i = Promise);
          var a = new AsyncIterator(wrap(t, r, n, o), i);
          return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
        }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
          return this;
        }), define(g, "toString", function () {
          return "[object Generator]";
        }), e.keys = function (t) {
          var e = Object(t),
            r = [];
          for (var n in e) r.push(n);
          return r.reverse(), function next() {
            for (; r.length;) {
              var t = r.pop();
              if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
          };
        }, e.values = values, Context.prototype = {
          constructor: Context,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          },
          stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
              return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                a = i.completion;
              if ("root" === i.tryLoc) return handle("end");
              if (i.tryLoc <= this.prev) {
                var c = n.call(i, "catchLoc"),
                  u = n.call(i, "finallyLoc");
                if (c && u) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                } else if (c) {
                  if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                } else {
                  if (!u) throw Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(t, e) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var o = this.tryEntries[r];
              if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                var i = o;
                break;
              }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
          },
          complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
          },
          finish: function finish(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
          },
          "catch": function _catch(t) {
            for (var e = this.tryEntries.length - 1; e >= 0; --e) {
              var r = this.tryEntries[e];
              if (r.tryLoc === t) {
                var n = r.completion;
                if ("throw" === n.type) {
                  var o = n.arg;
                  resetTryEntry(r);
                }
                return o;
              }
            }
            throw Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
              iterator: values(e),
              resultName: r,
              nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
          }
        }, e;
      }
      function asyncGeneratorStep(n, t, e, r, o, a, c) {
        try {
          var i = n[a](c),
            u = i.value;
        } catch (n) {
          return void e(n);
        }
        i.done ? t(u) : Promise.resolve(u).then(r, o);
      }
      function _asyncToGenerator(n) {
        return function () {
          var t = this,
            e = arguments;
          return new Promise(function (r, o) {
            var a = n.apply(t, e);
            function _next(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
              asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
          });
        };
      }
      function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[r] = t, e;
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == _typeof(i) ? i : i + "";
      }
      function _toPrimitive(t, r) {
        if ("object" != _typeof(t) || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != _typeof(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      /* eslint-disable @typescript-eslint/no-unused-vars */
      /* eslint-disable class-methods-use-this */
      var Places = /*#__PURE__*/function () {
        function Places() {
          _classCallCheck(this, Places);
          _defineProperty(this, "testString", "test");
          this.init = this.init.bind(this);
          this.initPlaceAutoCompletion = this.initPlaceAutoCompletion.bind(this);
        }
        return _createClass(Places, [{
          key: "init",
          value: function () {
            var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var _yield$google$maps$im, Place, AutocompleteSessionToken, AutocompleteSuggestion;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return google.maps.importLibrary("places");
                  case 2:
                    _yield$google$maps$im = _context.sent;
                    Place = _yield$google$maps$im.Place;
                    AutocompleteSessionToken = _yield$google$maps$im.AutocompleteSessionToken;
                    AutocompleteSuggestion = _yield$google$maps$im.AutocompleteSuggestion;
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function init() {
              return _init.apply(this, arguments);
            }
            return init;
          }()
        }, {
          key: "initPlaceAutoCompletion",
          value: function initPlaceAutoCompletion(Place, AutocompleteSessionToken, AutocompleteSuggestion) {
            var _this = this;
            var placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
              componentRestrictions: {
                country: ["dk"]
              }
            });
            var searchPlaceHolder = document.querySelector(".map-component-search");
            searchPlaceHolder.appendChild(placeAutocomplete);
            // @ts-ignore
            placeAutocomplete.addEventListener("gmp-placeselect", /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
                var place;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      place = _ref.place;
                      _this.handlePlaceSelection(place);
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        }, {
          key: "handlePlaceSelection",
          value: function () {
            var _handlePlaceSelection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(place) {
              var selectedPlaceData, selectedPlace, selectedPlaceLocation, coordinates;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return place.fetchFields({
                      fields: ["location"]
                    });
                  case 3:
                    selectedPlaceData = _context3.sent;
                    selectedPlace = selectedPlaceData === null || selectedPlaceData === void 0 ? void 0 : selectedPlaceData.place;
                    selectedPlaceLocation = Object.values(selectedPlace).find(function (placeData) {
                      return placeData === null || placeData === void 0 ? void 0 : placeData.location;
                    });
                    if (selectedPlaceLocation) {
                      coordinates = {
                        lat: selectedPlaceLocation.location.lat,
                        lng: selectedPlaceLocation.location.lng
                      };
                      document.dispatchEvent(new CustomEvent("Edition:ShowMap"));
                      document.dispatchEvent(new CustomEvent("Edition:FindNearbyStores", {
                        detail: {
                          position: coordinates
                        }
                      }));
                      document.dispatchEvent(new CustomEvent("Edition:PanPinIntoView", {
                        detail: {
                          position: coordinates
                        }
                      }));
                    }
                    _context3.next = 12;
                    break;
                  case 9:
                    _context3.prev = 9;
                    _context3.t0 = _context3["catch"](0);
                    console.error("Error handling place selection:", _context3.t0);
                  case 12:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3, null, [[0, 9]]);
            }));
            function handlePlaceSelection(_x2) {
              return _handlePlaceSelection.apply(this, arguments);
            }
            return handlePlaceSelection;
          }()
        }]);
      }();

      /***/
    },
    /***/"./resources/styles/app.css":
    /*!**********************************!*\
    !*** ./resources/styles/app.css ***!
    \**********************************/
    /***/
    function _resources_styles_appCss(__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_70749__) {
      __nested_webpack_require_70749__.r(__nested_webpack_exports__);
      // extracted by mini-css-extract-plugin

      /***/
    }

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/
  var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/
  function __nested_webpack_require_71121__(moduleId) {
    /******/ // Check if module is in cache
    /******/var cachedModule = __webpack_module_cache__[moduleId];
    /******/
    if (cachedModule !== undefined) {
      /******/return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = __webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    __webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_71121__);
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/
  __nested_webpack_require_71121__.m = __webpack_modules__;
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/chunk loaded */
  /******/
  (function () {
    /******/var deferred = [];
    /******/
    __nested_webpack_require_71121__.O = function (result, chunkIds, fn, priority) {
      /******/if (chunkIds) {
        /******/priority = priority || 0;
        /******/
        for (var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
        /******/
        deferred[i] = [chunkIds, fn, priority];
        /******/
        return;
        /******/
      }
      /******/
      var notFulfilled = Infinity;
      /******/
      for (var i = 0; i < deferred.length; i++) {
        /******/var _deferred$i = _slicedToArray(deferred[i], 3),
          chunkIds = _deferred$i[0],
          fn = _deferred$i[1],
          priority = _deferred$i[2];
        /******/
        var fulfilled = true;
        /******/
        for (var j = 0; j < chunkIds.length; j++) {
          /******/if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__nested_webpack_require_71121__.O).every(function (key) {
            return __nested_webpack_require_71121__.O[key](chunkIds[j]);
          })) {
            /******/chunkIds.splice(j--, 1);
            /******/
          } else {
            /******/fulfilled = false;
            /******/
            if (priority < notFulfilled) notFulfilled = priority;
            /******/
          }
          /******/
        }
        /******/
        if (fulfilled) {
          /******/deferred.splice(i--, 1);
          /******/
          var r = fn();
          /******/
          if (r !== undefined) result = r;
          /******/
        }
        /******/
      }
      /******/
      return result;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/
  (function () {
    /******/ // define getter functions for harmony exports
    /******/__nested_webpack_require_71121__.d = function (exports, definition) {
      /******/for (var key in definition) {
        /******/if (__nested_webpack_require_71121__.o(definition, key) && !__nested_webpack_require_71121__.o(exports, key)) {
          /******/Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/
  (function () {
    /******/__nested_webpack_require_71121__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/
  (function () {
    /******/ // define __esModule on exports
    /******/__nested_webpack_require_71121__.r = function (exports) {
      /******/if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module"
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/jsonp chunk loading */
  /******/
  (function () {
    /******/ // no baseURI
    /******/
    /******/ // object to store loaded and loading chunks
    /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/var installedChunks = {
      /******/"/src/assets/app": 0,
      /******/"src/assets/app": 0
      /******/
    };
    /******/
    /******/ // no chunk on demand loading
    /******/
    /******/ // no prefetching
    /******/
    /******/ // no preloaded
    /******/
    /******/ // no HMR
    /******/
    /******/ // no HMR manifest
    /******/
    /******/
    __nested_webpack_require_71121__.O.j = function (chunkId) {
      return installedChunks[chunkId] === 0;
    };
    /******/
    /******/ // install a JSONP callback for chunk loading
    /******/
    var webpackJsonpCallback = function webpackJsonpCallback(parentChunkLoadingFunction, data) {
      /******/var _data = _slicedToArray(data, 3),
        chunkIds = _data[0],
        moreModules = _data[1],
        runtime = _data[2];
      /******/ // add "moreModules" to the modules object,
      /******/ // then flag all "chunkIds" as loaded and fire callback
      /******/
      var moduleId,
        chunkId,
        i = 0;
      /******/
      if (chunkIds.some(function (id) {
        return installedChunks[id] !== 0;
      })) {
        /******/for (moduleId in moreModules) {
          /******/if (__nested_webpack_require_71121__.o(moreModules, moduleId)) {
            /******/__nested_webpack_require_71121__.m[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/
        }
        /******/
        if (runtime) var result = runtime(__nested_webpack_require_71121__);
        /******/
      }
      /******/
      if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
      /******/
      for (; i < chunkIds.length; i++) {
        /******/chunkId = chunkIds[i];
        /******/
        if (__nested_webpack_require_71121__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
          /******/installedChunks[chunkId][0]();
          /******/
        }
        /******/
        installedChunks[chunkId] = 0;
        /******/
      }
      /******/
      return __nested_webpack_require_71121__.O(result);
      /******/
    };
    /******/
    /******/
    var chunkLoadingGlobal = self["webpackChunkjema_agro_dk"] = self["webpackChunkjema_agro_dk"] || [];
    /******/
    chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/
    chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
    /******/
  })();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module depends on other loaded chunks and execution need to be delayed
  /******/
  __nested_webpack_require_71121__.O(undefined, ["src/assets/app"], function () {
    return __nested_webpack_require_71121__("./resources/app.ts");
  });
  /******/
  var __nested_webpack_exports__ = __nested_webpack_require_71121__.O(undefined, ["src/assets/app"], function () {
    return __nested_webpack_require_71121__("./resources/styles/app.css");
  });
  /******/
  __webpack_exports__ = __nested_webpack_require_71121__.O(__nested_webpack_exports__);
  /******/
  /******/
})();

/***/ },

/***/ "./src/app.scss"
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ },

/***/ "./src/app.ts"
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
() {



/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Check if module exists (development only)
/******/ 		if (__webpack_modules__[moduleId] === undefined) {
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkCool_Coffee"] = self["webpackChunkCool_Coffee"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;